module.exports = __webpack_public_path__ + "img/Last image OOBE French.00b9952f.png";